export enum UploadSources {
  cart = 'cart',
  cartItem = 'cart-item',
  workflow = 'workflow',
  workflowItem = 'workflow-item',
  account = 'account',
  accountItem = 'account-item',
  workshop = 'workshop',
  workshopItem = 'workshop-item',
  fabric = 'fabric',
  supplier = 'supplier',
  item = 'item',
  component = 'component',
  survey = 'survey',
  surveyLocation = 'survey-location',
  surveySublocation = 'survey-sublocation',
  surveyAccess = 'survey-access',
  calendar = 'calendar',
  setting = 'setting',
  other = 'other',
}

export const UploadSourcesNamming: Record<UploadSources, string> = {
  [UploadSources.cart]: 'Cart',
  [UploadSources.cartItem]: 'Cart Item',
  [UploadSources.workflow]: 'Workflow',
  [UploadSources.workflowItem]: 'Workflow Item',
  [UploadSources.account]: 'Account',
  [UploadSources.accountItem]: 'Account Item',
  [UploadSources.workshop]: 'Workshop',
  [UploadSources.workshopItem]: 'Workshop Item',
  [UploadSources.fabric]: 'Fabric',
  [UploadSources.supplier]: 'Supplier',
  [UploadSources.item]: 'Item',
  [UploadSources.component]: 'Component',
  [UploadSources.survey]: 'Survey',
  [UploadSources.surveyLocation]: 'Survey Location',
  [UploadSources.surveySublocation]: 'Survey Sublocation',
  [UploadSources.surveyAccess]: 'Survey Parking & Property Access',
  [UploadSources.calendar]: 'Calendar',
  [UploadSources.setting]: 'Setting',
  [UploadSources.other]: 'Other',
};

export type ViewModes =
  | 'details'
  | 'details-large'
  | 'small'
  | 'medium'
  | 'large';

export const SupportedFileTypes = [
  '.txt',
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.mp4',
  '.docx',
  '.doc',
  '.xlsx',
  '.xls',
];
